import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import titleMap from './titleMap'
import {
  PathwaysTable,
  PracticesCompleteText,
  StyledHeaderTwo,
  StyledProgressBarIndicator,
  TableHeaderWrapper,
  TextHiddenOverflow,
  UserPathwaysTableWrapper,
} from './component.styles'

const UserPathwaysTable = ({
  firstName,
  lastName,
  practiceType,
  rowData,
  totalPracticesComplete,
  totalPracticesCount,
}) => {
  let practicesCompleteText
  const isEducatorPractice = practiceType === 'educator'
  const isSchoolwidePractice = practiceType === 'sitewide'
  const isStudentActivity = practiceType === 'activity'
  const practiceTitle = titleMap?.[practiceType]?.title
  const columns = [
    {
      title: practiceTitle,
      component: <span>{practiceTitle}</span>,
      fieldValue: row => {
        if (typeof row === 'string') {
          return row
        } else {
          const { title } = row
          return <TextHiddenOverflow>{title}</TextHiddenOverflow>
        }
      },
    },
    {
      title: 'Status',
      component: <span>Status</span>,
      fieldValue: row => {
        if (typeof row !== 'string') {
          const { status } = row
          return <TextHiddenOverflow>{status || '—'}</TextHiddenOverflow>
        }
      },
    },
    {
      title: 'Date Marked Done',
      component: <span>Date Marked Done</span>,
      fieldValue: row => {
        if (typeof row !== 'string') {
          const { completedDate } = row
          const formattedCompletedDate = moment(completedDate).format(
            'MM/DD/YYYY',
          )
          return (
            <TextHiddenOverflow>
              {completedDate ? formattedCompletedDate : '—'}
            </TextHiddenOverflow>
          )
        }
      },
    },
  ]

  const gradeColumn = {
    title: 'Grade',
    component: <span>Grade</span>,
    fieldValue: row => {
      if (typeof row !== 'string') {
        const { grade } = row
        return <TextHiddenOverflow>{grade || '—'}</TextHiddenOverflow>
      }
    },
  }

  const progressMarkedColumn = {
    title: 'Progress Marked',
    component: <span>Progress Marked</span>,
    fieldValue: row => {
      if (typeof row !== 'string') {
        const { progress_marked } = row
        return <TextHiddenOverflow>{progress_marked || '—'}</TextHiddenOverflow>
      }
    },
  }

  if (isEducatorPractice) {
    const statusColIndex = columns.findIndex(({ title }) => title === 'Status')
    columns.splice(statusColIndex + 1, 0, progressMarkedColumn)
    practicesCompleteText = `${totalPracticesComplete} of ${totalPracticesCount} Educator Practices Complete`
  }
  if (isSchoolwidePractice) {
    practicesCompleteText = `${totalPracticesComplete} Schoolwide Practices Complete`
  }
  if (isStudentActivity) {
    const statusColIndex = columns.findIndex(
      ({ title }) => title === practiceTitle,
    )
    columns.splice(statusColIndex + 1, 0, gradeColumn)
    practicesCompleteText = `${totalPracticesComplete} Student Activities Complete`
  }

  return (
    <UserPathwaysTableWrapper>
      <TableHeaderWrapper>
        <StyledHeaderTwo>{`${lastName}, ${firstName}`}</StyledHeaderTwo>
        {isEducatorPractice && (
          <StyledProgressBarIndicator
            keyText={'pathways-practices-complete-progress-bar'}
            percentComplete={Math.floor(
              (totalPracticesComplete / totalPracticesCount) * 100,
            )}
            shouldRenderIndicator
            shouldRenderPercentage={false}
          />
        )}
        <PracticesCompleteText>{practicesCompleteText}</PracticesCompleteText>
      </TableHeaderWrapper>
      <PathwaysTable
        columns={columns}
        headThemeLight
        isCollapsible={true}
        key="user-drawer-pathways-table"
        multiColSpanValue={columns.length}
        rows={rowData}
      />
    </UserPathwaysTableWrapper>
  )
}

UserPathwaysTable.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  practiceType: PropTypes.string,
  rowData: PropTypes.array,
  totalPracticesComplete: PropTypes.number,
  totalPracticesCount: PropTypes.number,
}

export default UserPathwaysTable
